import { defineComponent, h, useAttrs } from 'vue'

export default defineComponent({
  name: 'VListItemContentCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        'div',
        {
          ...attrs,
          class: ['v-list-item-content', attrs.class]
        },
        slots.default?.()
      )
  }
})
